function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { SkeletonLoader } from "../../../../styled";
import { UnstyledTableLoadingWrapper } from "../../../unstyled/table/wrapper/UnstyledTableLoadingWrapper";
/*
    Wraps the Table component to show a skeleton style loader for the rows

    props
        (boolean, optional)   showRowLoading       When true, the loader will be shown
        (component, optional) RowLoadingComponent  The component to show in each body row cell when the loader is shown 
        (number, optional)    rowLoadingRowCount   The number of rows to show with the loader
*/

const TableLoadingWrapper = ({
  classPrepend = "styled",
  columns = [],
  rows = [],
  showRowLoading = false,
  RowLoadingComponent = () => /*#__PURE__*/React.createElement(SkeletonLoader, {
    height: "1rem",
    width: "100%"
  }),
  rowLoadingRowCount = 5,
  children,
  expandedRowRender = null,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTableLoadingWrapper, _extends({
    classPrepend: classPrepend,
    columns: columns,
    rows: rows,
    showRowLoading: showRowLoading,
    RowLoadingComponent: RowLoadingComponent,
    rowLoadingRowCount: rowLoadingRowCount,
    children: children,
    expandedRowRender: expandedRowRender
  }, rest));
};
export { TableLoadingWrapper };